import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import CourseComponent from '../component/CourseComponent'

const Courses = () => {
    useEffect(() => {
        document.title = "CareerGrads | Services"
    }, [])
    let { title } = useParams();


    return (
        <>
            <CourseComponent title={title} />
            {
                window.scrollTo(0, 0)
            }
        </>
    )
}

export default Courses
